// extracted by mini-css-extract-plugin
export default {"loading":"style_loading__KRMx2","history-vessel":"style_history-vessel__IRE8o","checkbox":"style_checkbox__gg5GO"};